export const validateUser = (data) => {
  const errors = {};

  if (!data.first_name?.trim()) {
    errors.first_name = 'First name is required';
  } else if (data.first_name.length > 40) {
    errors.first_name = 'First name cannot exceed 40 characters';
  }

  if (!data.last_name?.trim()) {
    errors.last_name = 'Last name is required';
  } else if (data.last_name.length > 40) {
    errors.last_name = 'Last name cannot exceed 40 characters';
  }

  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (data.email?.trim() && !emailPattern.test(data.email)) {
    errors.email = 'Email is invalid';
  }

  if ('password' in data) {
    if (!data.password.trim()) {
      errors.password = 'Password is required';
    } else if (data.password.length < 8) {
      errors.password = 'Password must be at least 8 characters long';
    } else if (!/[A-Z]/.test(data.password)) {
      errors.password = 'Password must contain at least one uppercase letter';
    } else if (!/[0-9]/.test(data.password)) {
      errors.password = 'Password must contain at least one number';
    } else if (!/[!@#$%^&*]/.test(data.password)) {
      errors.password = 'Password must contain at least one special character';
    }
  }

  if ('confirm_password' in data) {
    if (data.confirm_password && data.password !== data.confirm_password) {
      errors.confirm_password = 'Passwords do not match';
    }
  }

  return errors;
};